const IST_TIME_ZONE = "Asia/Kolkata";

const parseAsIst = (value) => {
  if (!value) return null;
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return new Date(`${value}T00:00:00+05:30`);
  }
  if (typeof value === "string" && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(value)) {
    return new Date(`${value.replace(" ", "T")}+05:30`);
  }
  return new Date(value);
};

export const formatIstDate = (value) => {
  const date = parseAsIst(value);
  return date && !Number.isNaN(date.getTime())
    ? date.toLocaleDateString("en-IN", { timeZone: IST_TIME_ZONE })
    : "Not set";
};

export const formatIstDateTime = (value) => {
  const date = parseAsIst(value);
  return date && !Number.isNaN(date.getTime())
    ? date.toLocaleString("en-IN", {
        timeZone: IST_TIME_ZONE,
        dateStyle: "medium",
        timeStyle: "short",
      })
    : "Not set";
};

export const getIstDateInputValue = (value = new Date()) => {
  const date = parseAsIst(value);
  return date && !Number.isNaN(date.getTime())
    ? new Intl.DateTimeFormat("en-CA", {
        timeZone: IST_TIME_ZONE,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(date)
    : "";
};